import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import { App } from './App.tsx'
import './styles/theme.css'
import './styles/app.css'

/**
 * Zive aktualizace: service worker se kontroluje kazdych pet minut a nova
 * verze se nasadi sama, vcetne tiche obnovy stranky. V rezimu nakupovani je
 * to bezpecne jen proto, ze stav nakupu i fronta neodeslanych zmen zije
 * v localStorage a reload prezije (viz lib/outbox.ts).
 */
registerSW({
  immediate: true,
  onRegisteredSW(_url, registration) {
    if (!registration) return
    setInterval(() => void registration.update(), 5 * 60 * 1000)
  },
})

const root = document.getElementById('root')
if (!root) throw new Error('#root v index.html chybi')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
